import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Button } from 'ui-components/components/button';
import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { PROCESS_STEPS, RESOURCE_ITEMS } from './constants';
import { messages } from './messages';
import style from './style.module.less';
import { ProcessStep } from '../overview/components/process-step';
import { useCanAccessFBSSetup } from '../overview/fulfilled-by-shipstation-ftu-wizard/use-fulfillment-ftu-wizard-state';
import { messages as overviewMessages } from '../overview/messages';

export const ResourcesPage = () => {
  const canAccessSetup = useCanAccessFBSSetup();

  return (
    <FlexColumn className={style['page-content']}>
      {canAccessSetup ? (
        <div className={style['banner-container']}>
          <BannerMessageV2
            bannerContainerClassName={style['banner-content-container']}
            className={style['banner-message']}
            content={<Text textType={TextType.Paragraph} value={messages.setupCompleteMessage} />}
            status={BannerStatus.Success}
          />
        </div>
      ) : null}
      <FlexColumn className={style['resources-section']} gap={Gap.Space24}>
        <Text textType={TextType.H2} value={messages.resourcesTitle} />
        <FlexColumn>
          {RESOURCE_ITEMS.map((item, index) => (
            <FlexRow key={index} className={style['resource-item']}>
              <FlexColumn className={style['resource-content']}>
                <Text textType={TextType.H4} value={item.title} />
                <Text className={style['resource-description']} textType={TextType.Paragraph} value={item.description} />
              </FlexColumn>
              <Button href={item.href} theme={THEME_CONSTANTS.link}>
                <FormattedMessage {...item.buttonLabel} />
              </Button>
            </FlexRow>
          ))}
        </FlexColumn>
      </FlexColumn>
      <div className={style['process-section']}>
        <div className={style['process-title']}>
          <Text textType={TextType.H2} value={overviewMessages.explanationTitle} />
        </div>
        <FlexRow className={style['process-steps-row']}>
          {PROCESS_STEPS.map((step, index) => (
            <ProcessStep key={index} description={step.description} stepNumber={index + 1} title={step.title} />
          ))}
        </FlexRow>
      </div>
    </FlexColumn>
  );
};
